import React, { useState, useEffect } from "react";
import "../css/loginPage.css";
import { Link, useParams, Navigate, useLocation } from "react-router-dom";
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import {
  doc,
  setDoc,
  collection,
  getDocs,
  query,
  where,
  updateDoc,
} from "firebase/firestore";
import { firestore } from "../firebase";
import { useLanguage } from "../LanguageContext";
import * as text from "../translation.json";
import Header from "../components/header";
import Footer from "../components/footer";

const auth = getAuth();
const db = firestore;

const LoginPage = (props) => {
  const { language } = useLanguage();
  let { page } = useParams();
  const [loggedIn, setLoggedIn] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [passwordInput, setPasswordInput] = useState("");
  const [tokenData, setTokenData] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  useEffect(() => {
    const verifyToken = async () => {
      const usersRef = collection(db, "invites");
      const q = query(usersRef, where("token", "==", token));

      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          setTokenData(doc.data());
        });
      }
    };
    if (token) {
      verifyToken();
    }
  }, [token]);

  useEffect(() => {
    document.title = "Mapli - Login";
    auth.onAuthStateChanged(function (user) {
      if (user) {
        setLoggedIn(true);
      } else {
        setLoggedIn(false);
      }
    });
  }, [auth]);

  const onLogin = (e) => {
    e.preventDefault();
    console.log(emailInput);
    console.log(passwordInput);
    signInWithEmailAndPassword(auth, emailInput, passwordInput)
      .then((userCredential) => {
        // Signed in
        const userDoc = doc(db, "users", userCredential.user.uid);

        if (token && emailInput === tokenData.email) {
          updateDoc(userDoc, {
            businesses: [tokenData.businessID],
            businessNames: [tokenData.businessName],
          });
        }

        const user = userCredential;
        console.log(user);
        console.log(user.user.uid);
        console.log(user.user.email);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorMessage);
      });
  };

  const onNewAccount = async (e) => {
    e.preventDefault();

    // const customerNumber = await createCustomerNumber();

    createUserWithEmailAndPassword(auth, emailInput, passwordInput)
      .then((userCredential) => {
        // Signed in

        const user = userCredential;
        console.log(user);
        console.log(user.user.uid);
        console.log(user.user.email);

        setDoc(doc(db, "users", user.user.uid), {
          epost: user.user.email,
          admin: false,
        });
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorMessage);
      });
  };

  const onForgotPassword = (e) => {
    e.preventDefault();

    console.log(emailInput);
    console.log(passwordInput);
    // signInWithEmailAndPassword(auth, "steffen@flyteori.no", "camper")
    //   .then((userCredential) => {
    //     // Signed in

    //     const user = userCredential;
    //     console.log(user);
    //     console.log(user.user.uid);
    //     console.log(user.user.email);

    //   })
    //   .catch((error) => {
    //     const errorCode = error.code;
    //     const errorMessage = error.message;
    //     console.log(errorMessage);
    //   });
  };

  return loggedIn ? (
    <Navigate
      to={!token ? "/MyBusiness" : `/MyBusiness?token=${token}`}
      replace
    />
  ) : (
    <>
      <Header />
      {page === "newAccount" ? (
        <div className='loginPageMainContainer'>
          <div className='loginpageLeft'>
            <h1>{text[language].logintext1}</h1>
            <h2>{text[language].logintext2}</h2>
          </div>
          <div className='loginpageRight'>
            <form className='loginForm'>
              <h2>{text[language].signup}</h2>
              <div className='loginFormInputFields'>
                <span>{text[language].email}</span>
                <input
                  placeholder={text[language].email}
                  value={emailInput}
                  onChange={(e) => {
                    setEmailInput(e.target.value);
                  }}
                  type='email'
                />
                <span>{text[language].password}</span>
                <input
                  placeholder={text[language].password}
                  value={passwordInput}
                  onChange={(e) => {
                    setPasswordInput(e.target.value);
                  }}
                  type='password'
                />
              </div>

              <a
                href={!token ? "/login" : `/login?token=${token}`}
                style={{ display: "flex", color: "black", marginTop: "10px" }}>
                <div style={{ textDecoration: "underline" }}>
                  {text[language].alreadyhaveaccount}
                </div>
                <div className='loginIfUser'>{text[language].login}</div>
              </a>

              <button className='loginButton' onClick={onNewAccount}>
                {text[language].signup}
              </button>
              <div className='termsTextBoks'>
                {text[language].termsofservice}
                <a href='#' className='loginIfUser'>
                  {text[language].mapliaccount}
                </a>
              </div>
            </form>
          </div>
        </div>
      ) : page === "forgotPassword" ? (
        <div className='loginPageMainContainer'>
          <div className='loginpageLeft'>
            <h1>{text[language].logintext1}</h1>
            <h2>{text[language].logintext2}</h2>
          </div>
          <div className='loginpageRight'>
            <form className='loginForm'>
              <h2>{text[language].forgotpassword}</h2>
              <div className='loginFormInputFields'>
                <span>{text[language].email}</span>
                <input
                  onChange={(e) => {
                    setEmailInput(e.target.value);
                  }}
                  placeholder={text[language].email}
                  type='email'
                />
              </div>

              <button
                className='loginButton'
                style={{ marginTop: "20px" }}
                onClick={onForgotPassword}>
                {text[language].resetpassword}
              </button>

              <a
                href={!token ? "/login" : `/login?token=${token}`}
                style={{
                  display: "flex",
                  color: "black",
                  marginTop: "10px",
                  marginBottom: "35px",
                }}>
                <div style={{ textDecoration: "underline" }}>
                  {text[language].goback}
                </div>
                <div className='loginIfUser'>{text[language].login}</div>
              </a>
            </form>
          </div>
        </div>
      ) : (
        <div className='loginPageMainContainer'>
          <div className='loginpageLeft'>
            <h1>{text[language].logintext1}</h1>
            <h2>{text[language].logintext2}</h2>
          </div>
          <div className='loginpageRight'>
            <form className='loginForm'>
              <h2>{text[language].login}</h2>
              <div className='loginFormInputFields'>
                <span>{text[language].email}</span>
                <input
                  onChange={(e) => {
                    setEmailInput(e.target.value);
                  }}
                  placeholder={text[language].email}
                  type='email'
                />
                <span>{text[language].password}</span>
                <input
                  onChange={(e) => {
                    setPasswordInput(e.target.value);
                  }}
                  placeholder={text[language].password}
                  type='password'
                />
              </div>
              <a
                href={
                  !token
                    ? "/login/forgotPassword"
                    : `/login/forgotPassword?token=${token}`
                }
                className='forgotPassword'>
                {text[language].forgotpassword}
              </a>

              <button className='loginButton' onClick={onLogin}>
                {text[language].login}
              </button>
              <a
                href={
                  !token
                    ? "/login/newAccount"
                    : `/login/newAccount?token=${token}`
                }
                className='newAccountButton'>
                {text[language].signup}
              </a>
            </form>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default LoginPage;
